import { useSelector } from 'react-redux';

import type { AssetWithBalance } from '@/types';
import selectors from '../flux/selectors.js';

function useEnrichedCombinedAssets() {
  return useSelector<unknown, AssetWithBalance[]>(
    selectors.fiatBalances
      .sortedEnabledAssetsWithParentCombinedWithBalanceInActiveAccount,
  );
}

export default useEnrichedCombinedAssets;
